<div class="container iep-form-container" style="width: 97%">
  <div class="row">
    <div class="col-lg-12">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <h4 style="margin-bottom: 3px; margin-top: 5px">{{ title }}</h4>
        </div>

        <div class="panel-body">
          <form
            id="add-load-form"
            [formGroup]="formMasterGroup"
            #formDirective="ngForm"
            (ngSubmit)="submit()"
            novalidate
          >
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>{{ 'addLoad.title' | translate }}</h6>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'selectSite' | translate
                      }}<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>{{
                        'pleaseSelectSite' | translate
                      }}</mat-label>
                      <mat-select
                        [(ngModel)]="load.siteID"
                        ngDefaultControl
                        formControlName="siteNameCtr"
                        (ngModelChange)="onSiteChange()"
                        required
                      >
                        <mat-option
                          *ngFor="let item of sites"
                          [value]="item.SiteId"
                          >{{ item.SiteName }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="isFieldHasError('siteNameCtr', 'required')"
                        >{{ 'pleaseSelectSite' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >KPI Utility<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>Please Select Utility</mat-label>
                      <mat-select
                        [(ngModel)]="load.kpiUtility"
                        ngDefaultControl
                        formControlName="kpiUtilityCtr"
                        (ngModelChange)="onUtilityChange($event)"
                        required
                      >
                        <mat-option
                          *ngFor="let item of configuredKpiUtilities"
                          [value]="item"
                          >{{ item }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="isFieldHasError('kpiUtilityCtr', 'required')"
                        >Please Select Utility</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'addLoad.selectMeter' | translate }}
                      <span
                        *ngIf="load.hasEnergyMeter !== 'NO'"
                        class="iep-required"
                        >*</span
                      ></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>{{
                        'addLoad.selectAMeter' | translate
                      }}</mat-label>
                      <input
                        matInput
                        type="text"
                        [(ngModel)]="load.meter.meterId"
                        formControlName="meterCtr"
                        *ngIf="editLoad"
                      />
                      <mat-select
                        [(ngModel)]="formData.meter"
                        ngDefaultControl
                        formControlName="meterCtr"
                        *ngIf="!editLoad"
                      >
                        <mat-option
                          *ngFor="let item of availableMeters"
                          [value]="item"
                          >{{ item.meterId }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="isFieldHasError('meterCtr', 'required')"
                        >{{ 'addLoad.selectAMeter' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'addLoad.loadName' | translate }}
                      <span class="iep-required">*</span>
                    </mat-label>
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        [(ngModel)]="load.name"
                        matInput
                        placeholder="Load Name"
                        (change)="checkDuplicatedLoadName()"
                        ngDefaultControl
                        formControlName="loadNameCtr"
                        required
                      />
                      <mat-error
                        *ngIf="isFieldHasError('loadNameCtr', 'required')"
                        >{{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="isFieldHasError('loadNameCtr', 'duplicated')"
                        >{{ 'addLoad.duplicateLoadName' | translate }}
                        {{ load.siteID }}.</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label
                      *ngIf="
                        load.kpiUtility !== 'Water' && load.kpiUtility !== 'Gas'
                      "
                      class="label-input pull-right"
                      >{{ 'addLoad.KWRating' | translate }}
                      <span class="iep-required">*</span></mat-label
                    >
                    <mat-label
                      *ngIf="
                        load.kpiUtility === 'Water' || load.kpiUtility === 'Gas'
                      "
                      class="label-input pull-right"
                      >Capacity Rating:
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        matInput
                        type="number"
                        [(ngModel)]="load.kwRating"
                        ngDefaultControl
                        formControlName="kwRatingCtr"
                        placeholder="KW Rating"
                      />
                      <mat-error
                        *ngIf="isFieldHasError('kwRatingCtr', 'required')"
                        >{{ 'requiredField' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'addLoad.loadType' | translate }}
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <mat-label>{{
                        'addLoad.selectLoadType' | translate
                      }}</mat-label>
                      <mat-select
                        [(ngModel)]="load.type"
                        ngDefaultControl
                        formControlName="loadTypeCtr"
                        (ngModelChange)="changeLoadType()"
                      >
                        <mat-option>{{
                          'addLoad.selectLoadType' | translate
                        }}</mat-option>
                        <mat-option
                          *ngFor="let item of loadTypes"
                          [value]="item"
                          >{{ item }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="isFieldHasError('loadTypeCtr', 'required')"
                        >{{ 'requiredField' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Make: <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        [(ngModel)]="load.make"
                        matInput
                        placeholder="Make"
                        ngDefaultControl
                        formControlName="makeCtr"
                        required
                      />
                      <mat-error *ngIf="isFieldHasError('makeCtr', 'required')"
                        >This field is required.
                      </mat-error>
                      <mat-error *ngIf="isFieldHasError('makeCtr', 'minlength')"
                        >Make name too short.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="load.type === 'Transformer'">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'addLoad.KVARating' | translate }}
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        matInput
                        type="number"
                        [(ngModel)]="load.kvaRating"
                        ngDefaultControl
                        formControlName="kvaRatingCtr"
                        placeholder="KVA Rating"
                      />
                      <mat-error
                        *ngIf="isFieldHasError('kvaRatingCtr', 'required')"
                        >{{ 'requiredField' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label
                      *ngIf="
                        load.type !== 'Transformer' &&
                        load.type !== 'Generic / Area Specific Sensor' &&
                        load.kpiUtility !== 'Water' &&
                        load.kpiUtility !== 'Gas'
                      "
                      class="label-input pull-right"
                      >Select Sub Type:</mat-label
                    >
                    <mat-label
                      *ngIf="load.type === 'Transformer'"
                      class="label-input pull-right"
                      >Threshold KW:
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field
                      *ngIf="
                        load.type !== 'Transformer' &&
                        load.type !== 'Generic / Area Specific Sensor' &&
                        load.kpiUtility !== 'Water' &&
                        load.kpiUtility !== 'Gas'
                      "
                    >
                      <mat-label>-- Select Load Sub Type --</mat-label>
                      <mat-select
                        [(ngModel)]="load.subType"
                        ngDefaultControl
                        formControlName="subTypeCtr"
                        (ngModelChange)="changeSubLoadType()"
                      >
                        <mat-option>-- Select Load Sub Type --</mat-option>
                        <mat-option
                          *ngFor="let item of loadSubTypes"
                          [value]="item.value"
                          >{{ item.text }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="load.type === 'Transformer'">
                      <input
                        matInput
                        type="number"
                        [(ngModel)]="load.kwThreshold"
                        ngDefaultControl
                        formControlName="kwThresholdCtr"
                        placeholder="Threshold KW"
                      />
                      <mat-error
                        *ngIf="isFieldHasError('kwThresholdCtr', 'required')"
                        >This field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label
                      *ngIf="
                        load.kpiUtility !== 'Water' && load.kpiUtility !== 'Gas'
                      "
                      class="label-input pull-right"
                    >
                      Number of Phases:
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field
                      *ngIf="
                        load.kpiUtility !== 'Water' && load.kpiUtility !== 'Gas'
                      "
                    >
                      <mat-label>-- Select Phase --</mat-label>
                      <mat-select
                        [(ngModel)]="load.phaseType"
                        ngDefaultControl
                        formControlName="phasetypeCtr"
                        [ngModelOptions]="{ standalone: true }"
                        required
                      >
                        <mat-option>-- Select Phase --</mat-option>
                        <mat-option value="Single Phase"
                          >Single Phase</mat-option
                        >
                        <mat-option value="Three Phase">Three Phase</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  class="col-md-5"
                  style="display: flex; align-items: flex-end"
                >
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right">{{
                      'addLoad.parametersMonitored' | translate
                    }}</mat-label>
                  </div>
                  <div class="col-md-8">
                    <mat-checkbox
                      [(ngModel)]="paramsAll"
                      ngDefaultControl
                      (change)="checkAllParams()"
                      [ngModelOptions]="{ standalone: true }"
                    >
                      {{ 'selectAll' | translate }}</mat-checkbox
                    >
                  </div>
                </div>
                <div class="col-md-7">
                  <div
                    class="row"
                    style="display: flex; align-items: center"
                    *ngFor="let item of load.parameters; let $index = index"
                  >
                    <div class="col-md-4">
                      <mat-checkbox
                        [(ngModel)]="item.selected"
                        ngDefaultControl
                        (change)="changeChkBoxParam($index)"
                        [ngModelOptions]="{ standalone: true }"
                      >
                        {{ item.name }}</mat-checkbox
                      >
                    </div>
                    <div class="col-md-8">
                      <mat-form-field *ngIf="item.value === 'temperature'">
                        <mat-label>{{ 'addLoad.unit' | translate }}</mat-label>
                        <mat-select
                          [(ngModel)]="load.parameters[$index].unit"
                          ngDefaultControl
                          formControlName="parameterCtr_{{ $index }}"
                          [disabled]="!item.selected"
                          (ngModelChange)="showAndHideParamErrorLabel()"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          <mat-option>Unit</mat-option>
                          <mat-option
                            *ngFor="let unitItem of temperatureUnits"
                            [value]="unitItem"
                            >{{ unitItem }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="
                            isFieldHasError(
                              'parameterCtr_' + $index,
                              'required'
                            )
                          "
                          >{{ 'requiredField' | translate }}</mat-error
                        >
                      </mat-form-field>
                      <mat-form-field *ngIf="item.value === 'pressure'">
                        <mat-label>{{ 'addLoad.unit' | translate }}</mat-label>
                        <mat-select
                          [(ngModel)]="load.parameters[$index].unit"
                          ngDefaultControl
                          formControlName="parameterCtr_{{ $index }}"
                          [disabled]="!item.selected"
                          (ngModelChange)="showAndHideParamErrorLabel()"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          <mat-option>{{
                            'addLoad.unit' | translate
                          }}</mat-option>
                          <mat-option
                            *ngFor="let unitItem of pressureUnits"
                            [value]="unitItem"
                            >{{ unitItem }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="
                            isFieldHasError(
                              'parameterCtr_' + $index,
                              'required'
                            )
                          "
                          >{{ 'requiredField' | translate }}</mat-error
                        >
                      </mat-form-field>
                      <mat-form-field *ngIf="item.value === 'flowOutput'">
                        <input
                          [(ngModel)]="load.parameters[$index].unit"
                          ngDefaultControl
                          matInput
                          placeholder="Unit"
                          formControlName="parameterCtr_{{ $index }}"
                        />
                        <mat-error
                          *ngIf="
                            isFieldHasError(
                              'parameterCtr_' + $index,
                              'required'
                            )
                          "
                          >{{ 'requiredField' | translate }}</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row" style="display: flex; align-items: center">
                    <div class="col-md-4">
                      <mat-checkbox
                        [(ngModel)]="paramOther.checked"
                        [ngModelOptions]="{ standalone: true }"
                        ngDefaultControl
                        (change)="changeChkBoxParamOther()"
                      >
                        {{ 'addLoad.others' | translate }}</mat-checkbox
                      >
                    </div>
                    <div class="col-md-8">
                      <div class="col-md-6">
                        <mat-form-field>
                          <input
                            [(ngModel)]="paramOther.name"
                            matInput
                            ngDefaultControl
                            placeholder="Measurement Name"
                            (change)="showAndHideParamErrorLabel()"
                            [disabled]="paramOther.checked !== true"
                            formControlName="paramOtherNameCtr"
                          />
                          <mat-error
                            *ngIf="
                              isFieldHasError('paramOtherNameCtr', 'required')
                            "
                            >{{ 'requiredField' | translate }}</mat-error
                          >
                        </mat-form-field>
                      </div>
                      <div class="col-md-6">
                        <mat-form-field>
                          <input
                            [(ngModel)]="paramOther.unit"
                            matInput
                            ngDefaultControl
                            placeholder="Unit"
                            (change)="showAndHideParamErrorLabel()"
                            [disabled]="paramOther.checked !== true"
                            formControlName="paramOtherUnitCtr"
                          />
                          <mat-error
                            *ngIf="
                              isFieldHasError('paramOtherUnitCtr', 'required')
                            "
                            >{{ 'requiredField' | translate }}</mat-error
                          >
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <!-- StratificationTank -->
            <mat-expansion-panel
              [expanded]="true"
              *ngIf="load.subType === 'StratificationTank'"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>{{ 'addLoad.stratificationTank.title' | translate }}</h6>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'addLoad.stratificationTank.numOfInlets' | translate
                      }}<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        [(ngModel)]="formData.inputNo"
                        matInput
                        (ngModelChange)="
                          generateFlowChannels(
                            'INLETS',
                            formData.inputNo,
                            'StratificationTank'
                          )
                        "
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.inletValue'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inputNoCtr"
                        required
                      />
                      <mat-error
                        *ngIf="isFieldHasError('inputNoCtr', 'required')"
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasError('inputNoCtr', 'min') ||
                          isFieldHasError('inputNoCtr', 'max')
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.inletRange'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{ 'addLoad.stratificationTank.numOfOutlets' | translate
                      }}<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        [(ngModel)]="formData.outputNo"
                        matInput
                        (ngModelChange)="
                          generateFlowChannels(
                            'OUTLETS',
                            formData.outputNo,
                            'StratificationTank'
                          )
                        "
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.outletValue'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="outputNoCtr"
                        required
                      />
                      <mat-error
                        *ngIf="isFieldHasError('outputNoCtr', 'required')"
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasError('outputNoCtr', 'min') ||
                          isFieldHasError('outputNoCtr', 'max')
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.outletRange'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >{{
                        'addLoad.stratificationTank.numOfThermoclines'
                          | translate
                      }}<span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        [(ngModel)]="load.thermoclines"
                        matInput
                        (change)="onThermoclinesChange()"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.thermalValue'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="thermoclinesCtr"
                        required
                      />
                      <mat-error
                        *ngIf="isFieldHasError('thermoclinesCtr', 'required')"
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.thermoclinesRequired'
                            | translate
                        }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasError(
                            'thermoclinesCtr',
                            'lessThanInletInvalid'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.thermoclinesRange'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <mat-label class="label-input">{{
                  'addLoad.stratificationTank.inletDetails.label' | translate
                }}</mat-label>
              </div>
              <hr />
              <div class="row">
                <div
                  formArrayName="inletItems"
                  class="col-md-3"
                  *ngFor="let flowChannel of load.inlets; let $index = index"
                >
                  <div [formGroupName]="$index">
                    <mat-label class="label-input" style="font-weight: bold"
                      >{{
                        'addLoad.stratificationTank.inletDetails.enterDetails'
                          | translate
                      }}
                      {{ $index + 1 }}:</mat-label
                    ><br />
                    <mat-form-field>
                      <input
                        [(ngModel)]="flowChannel.name"
                        matInput
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.alphanumeric'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inputNameCtr"
                        required
                        (change)="
                          onInputNameStratificationTankChange($index, 'inlet')
                        "
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'minlength'
                          ) ||
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'maxlength'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.length' | translate
                        }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'inputInletNameUniqueValidator',
                            'inlet'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.repeatName'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        number-only
                        matInput
                        [(ngModel)]="flowChannel.flowChannelID"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.flowChannel'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inputIDCtr"
                        required
                        (change)="onFlowChannelIDChange($index, 'inlet')"
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputIDCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputIDCtr',
                            $index,
                            'inputInletIDUniqueValidator',
                            'inlet'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.repeatFlowChannel'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        number-only
                        matInput
                        [(ngModel)]="flowChannel.insiteFlowChannelID"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.inSiteflowChannel'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inputInsiteIDCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputInsiteIDCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.diameter"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.innerDiameter'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletDiameterCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletDiameterCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.massFlowRate"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.flowChannelMFR'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletMFRCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletMFRCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.lowerThresholdTempertaure"
                        (change)="
                          onLowerThresholdTemperatureChange($index, 'inlet')
                        "
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.lowerThresholdTemp'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletThresholdTempCtr"
                        required
                      />
                      <!-- stratification-tank-inlet-lower-threshold -->
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletThresholdTempCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletThresholdTempCtr',
                            $index,
                            'isInletLowerThresholdValid'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.inletDetails.errMsg.lowerThresholdGreater'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.upperThresholdTemperature"
                        (change)="
                          onUpperThresholdTemperatureChange($index, 'inlet')
                        "
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.upperThresholdTemp'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletUpperThresholdTempCtr"
                        required
                      />
                      <!-- stratification-tank-inlet-lower-threshold -->
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'isInletUpperThresholdValid'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.inletDetails.errMsg.upperThresholdLess'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-checkbox
                      [(ngModel)]="flowChannel.valveSwitchPresent"
                      ngDefaultControl
                      [ngModelOptions]="{ standalone: true }"
                    >
                      {{
                        'addLoad.stratificationTank.hasValve' | translate
                      }}</mat-checkbox
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <mat-label class="label-input">{{
                  'addLoad.stratificationTank.outletDetails.label' | translate
                }}</mat-label>
              </div>
              <hr />
              <div class="row">
                <div
                  formArrayName="outletItems"
                  class="col-md-3"
                  *ngFor="let flowChannel of load.outlets; let $index = index"
                >
                  <div [formGroupName]="$index">
                    <mat-label class="label-input" style="font-weight: bold"
                      >{{
                        'addLoad.stratificationTank.outletDetails.enterDetails'
                          | translate
                      }}
                      {{ $index + 1 }}:</mat-label
                    ><br />
                    <mat-form-field>
                      <input
                        [(ngModel)]="flowChannel.name"
                        matInput
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.alphanumeric'
                            | translate
                        }}"
                        (change)="
                          onInputNameStratificationTankChange($index, 'outlet')
                        "
                        ngDefaultControl
                        formControlName="inputNameCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'minlength',
                            'outlet'
                          ) ||
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'maxlength',
                            'outlet'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.length' | translate
                        }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputNameCtr',
                            $index,
                            'inputOutletNameUniqueValidator',
                            'outlet'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.repeatName'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-form-field>
                      <input
                        number-only
                        matInput
                        [(ngModel)]="flowChannel.flowChannelID"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.flowChannel'
                            | translate
                        }}"
                        (change)="onFlowChannelIDChange($index, 'outlet')"
                        ngDefaultControl
                        formControlName="inputIDCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputIDCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputIDCtr',
                            $index,
                            'inputOutletIDUniqueValidator',
                            'outlet'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.errMsg.repeatFlowChannel'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-form-field>
                      <input
                        number-only
                        matInput
                        [(ngModel)]="flowChannel.insiteFlowChannelID"
                        placeholder="{{'addLoad.stratificationTank.placeholder.inSiteflowChannel' | translate}"
                        ngDefaultControl
                        formControlName="inputInsiteIDCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inputInsiteIDCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.diameter"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.innerDiameter'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletDiameterCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletDiameterCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.massFlowRate"
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.flowChannelMFR'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletMFRCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletMFRCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.lowerThresholdTempertaure"
                        (change)="
                          onLowerThresholdTemperatureChange($index, 'outlet')
                        "
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.lowerThresholdTemp'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletThresholdTempCtr"
                        required
                      />
                      <!-- stratification-tank-inlet-lower-threshold -->
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletThresholdTempCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletThresholdTempCtr',
                            $index,
                            'isOutletLowerThresholdValid',
                            'outlet'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.outletDetails.errMsg.lowerThresholdGreater'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.upperThresholdTemperature"
                        (change)="
                          onUpperThresholdTemperatureChange($index, 'outlet')
                        "
                        placeholder="{{
                          'addLoad.stratificationTank.placeholder.upperThresholdTemp'
                            | translate
                        }}"
                        ngDefaultControl
                        formControlName="inletUpperThresholdTempCtr"
                        required
                      />
                      <!-- stratification-tank-inlet-lower-threshold -->
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        {{ 'requiredField' | translate }}
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinArray(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'isOutLetUpperThresholdValid',
                            'outlet'
                          )
                        "
                      >
                        {{
                          'addLoad.stratificationTank.outletDetails.errMsg.upperThresholdLess'
                            | translate
                        }}
                      </mat-error>
                    </mat-form-field>
                    <br />
                    <mat-checkbox
                      [(ngModel)]="flowChannel.valveSwitchPresent"
                      ngDefaultControl
                      [ngModelOptions]="{ standalone: true }"
                    >
                      {{
                        'addLoad.stratificationTank.hasValve' | translate
                      }}</mat-checkbox
                    >
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <!-- Generic -->
            <mat-expansion-panel
              [expanded]="true"
              *ngIf="
                load.type === 'Generic / Area Specific Sensor' ||
                (load.subType === 'Generic Load' && load.type === 'Turning')
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>
                    {{
                      'addLoad.stratificationTank.sensorDetails.title'
                        | translate
                    }}
                  </h6>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Number of Input Sensing Points:<span class="iep-required"
                        >*</span
                      ></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        [(ngModel)]="formData.inputNo"
                        matInput
                        (ngModelChange)="
                          generateFlowChannels(
                            'INLETS',
                            formData.inputNo,
                            'Generic'
                          )
                        "
                        placeholder="Numeric value for Input Sensing Point"
                        ngDefaultControl
                        formControlName="inputNoSensorCtr"
                        required
                      />
                      <mat-error
                        *ngIf="isFieldHasError('inputNoSensorCtr', 'required')"
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasError('inputNoSensorCtr', 'min') ||
                          isFieldHasError('inputNoSensorCtr', 'max')
                        "
                      >
                        Number of Sensing Point is greater than 0 and less than
                        or equal to 30.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Has Energy Meter?</mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <section class="example-section">
                      <input
                        ngDefaultControl
                        [ngModelOptions]="{ standalone: true }"
                        type="radio"
                        [(ngModel)]="load.hasEnergyMeter"
                        [checked]="load.hasEnergyMeter === 'YES'"
                        name="flowMeter"
                        value="YES"
                        (ngModelChange)="onHasEnergyMeterChange('generic')"
                      />
                      <mat-label class="example-margin"> &nbsp; Yes</mat-label>
                      &nbsp;
                      <input
                        ngDefaultControl
                        [ngModelOptions]="{ standalone: true }"
                        type="radio"
                        [(ngModel)]="load.hasEnergyMeter"
                        [checked]="load.hasEnergyMeter === 'NO'"
                        name="flowMeter"
                        value="NO"
                        (ngModelChange)="onHasEnergyMeterChange('generic')"
                      />
                      <mat-label class="example-margin"> &nbsp; No</mat-label>
                    </section>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input">Hardware Version</mat-label>
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        matInput
                        ngDefaultControl
                        formControlName="hardwareVersionCtr"
                        [(ngModel)]="load.hardwareVersion"
                        placeholder=""
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="load.hasEnergyMeter === 'NO'">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Machine ID:
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        [(ngModel)]="load.machineID"
                        matInput
                        type="number"
                        (change)="checkDuplicatedMachineId()"
                        placeholder="Enter Unique ID for Load"
                        ngDefaultControl
                        formControlName="machineIDCtr"
                        required
                      />
                      <mat-error
                        *ngIf="isFieldHasError('machineIDCtr', 'required')"
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="isFieldHasError('machineIDCtr', 'duplicated')"
                      >
                        Duplicated Machine ID for site {{ load.siteID }}.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <mat-label class="label-input">Sensing Point Details</mat-label>
              </div>
              <hr />
              <div class="row">
                <div
                  formArrayName="inletSensingItems"
                  class="col-md-3"
                  *ngFor="let flowChannel of load.inlets; let $index = index"
                >
                  <div [formGroupName]="$index">
                    <mat-label class="label-input" style="font-weight: bold"
                      >Enter details of Sensing Point
                      {{ $index + 1 }}:</mat-label
                    ><br />
                    <mat-form-field>
                      <input
                        [(ngModel)]="flowChannel.name"
                        matInput
                        placeholder="Enter Sensed Parameter Name"
                        (change)="onInputNameSensorChange($index, 'inlet')"
                        ngDefaultControl
                        formControlName="inputNameCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inputNameCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inputNameCtr',
                            $index,
                            'minlength'
                          ) ||
                          isFieldHasErrorinSensing(
                            'inputNameCtr',
                            $index,
                            'maxlength'
                          )
                        "
                      >
                        Please legthen this text to 1 characters and less than
                        15 characters.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inputNameCtr',
                            $index,
                            'inputInletNameUniqueValidator',
                            'inlet'
                          )
                        "
                      >
                        Name cannot be repeated.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.flowChannelID"
                        placeholder="Enter Flow Channel ID"
                        (change)="onFlowChannelIDSensorChange($index, 'inlet')"
                        ngDefaultControl
                        formControlName="inputIDCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inputIDCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inputIDCtr',
                            $index,
                            'minlength'
                          ) ||
                          isFieldHasErrorinSensing(
                            'inputNameCtr',
                            $index,
                            'maxlength'
                          )
                        "
                      >
                        Please legthen this text to 1 characters and less than
                        60 characters.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inputIDCtr',
                            $index,
                            'inputInletIDUniqueValidator',
                            'inlet'
                          )
                        "
                      >
                        FlowChannelID cannot be repeated.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.ioChannnelSerialNumber"
                        placeholder="Enter IO Serial Number"
                        ngDefaultControl
                        formControlName="ioChannnelSerialNumberCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'ioChannnelSerialNumberCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>-- Select Parameter Type --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.parameterType"
                        ngDefaultControl
                        formControlName="parameterTypeCtr"
                      >
                        <mat-option
                          *ngFor="let item of hydraulicParameterType"
                          [value]="item"
                          >{{ item }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'parameterTypeCtr',
                            $index,
                            'required'
                          )
                        "
                        >Please Select Parameter Type</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="
                          flowChannel.sensor.parameterTypeDisplayValue
                        "
                        placeholder="Enter ParameterType DisplayName"
                        ngDefaultControl
                        formControlName="parameterTypeDisplayValueCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'minlength'
                          ) ||
                          isFieldHasErrorinSensing(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'maxlength'
                          )
                        "
                      >
                        Please legthen this text to 2 characters and less than
                        30 characters.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>-- Select Sensor Output Type --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.outputType"
                        (ngModelChange)="onOutTypeChange('Generic', $index)"
                        ngDefaultControl
                        formControlName="outputTypeCtr"
                        required
                      >
                        <mat-option>-- Select Sensor Output Type --</mat-option>
                        <mat-option
                          *ngFor="let item of hydraulicOutputType"
                          [value]="item.value"
                          >{{ item.text }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'outputTypeCtr',
                            $index,
                            'required'
                          )
                        "
                        >Select Sensor Output Type</mat-error
                      >
                    </mat-form-field>
                    <!-- Check later -->
                    <mat-form-field
                      *ngIf="flowChannel.sensor.outputType === 'Switch'"
                    >
                      <mat-label>-- Select DI0 / DI1 --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.digitalOutputMapping"
                        ngDefaultControl
                        formControlName="digitalOutputMappingCtr"
                        required
                      >
                        <mat-option>-- Select DI0 / DI1 --</mat-option>
                        <mat-option
                          *ngFor="let item of digitalOutputMapping"
                          [value]="item"
                          >{{ item.di_0 }} / {{ item.di_1 }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'digitalOutputMappingCtr',
                            $index,
                            'required'
                          )
                        "
                        >Select DI0 / DI1</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.sensor.sensorPartNumber"
                        placeholder="Enter Sensor Part Number"
                        ngDefaultControl
                        formControlName="sensorPartNumberCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'sensorPartNumberCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.lowerThresholdTempertaure"
                        placeholder="Enter Lower Threshold Temperature"
                        (change)="onLowerThresholdSensorChange($index, 'inlet')"
                        ngDefaultControl
                        formControlName="inletThresholdTempCtr"
                        required
                      />
                      <!-- stratification-tank-inlet-lower-threshold -->
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inletThresholdTempCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inletThresholdTempCtr',
                            $index,
                            'isInletLowerThresholdValid'
                          )
                        "
                      >
                        Inlet Lower Threshold cannot be Equal / Greater than
                        Upper Threshold Value
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.upperThresholdTemperature"
                        placeholder="Enter Upper Threshold Temperature"
                        (change)="onUpperThresholdSensorChange($index, 'inlet')"
                        ngDefaultControl
                        formControlName="inletUpperThresholdTempCtr"
                        required
                      />
                      <!-- stratification-tank-inlet-lower-threshold -->
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinSensing(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'isInletUpperThresholdValid'
                          )
                        "
                      >
                        Inlet Upper Threshold cannot be less than Equal / Lower
                        than Lower Threshold Value
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <!-- Hydraulic Unit -->
            <mat-expansion-panel
              [expanded]="true"
              *ngIf="
                load.type === 'Turning' && load.subType === 'Hydraulic Unit'
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>Hydraulic Unit Details</h6>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Number of Input Sensing Points:<span class="iep-required"
                        >*</span
                      ></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        [(ngModel)]="formData.inputNo"
                        matInput
                        (ngModelChange)="
                          generateFlowChannels(
                            'INLETS',
                            formData.inputNo,
                            'Hydraulic'
                          )
                        "
                        placeholder="Numeric value for Input Sensing Point"
                        ngDefaultControl
                        formControlName="inputNoHydraulicCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasError('inputNoHydraulicCtr', 'required')
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasError('inputNoHydraulicCtr', 'min') ||
                          isFieldHasError('inputNoHydraulicCtr', 'max')
                        "
                      >
                        Number of Input Sensing Point is greater than 0 and less
                        than or equal to 30.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Number of Output Sensing Points:<span
                        class="iep-required"
                        >*</span
                      ></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        [(ngModel)]="formData.outputNo"
                        matInput
                        (ngModelChange)="
                          generateFlowChannels(
                            'OUTLETS',
                            formData.outputNo,
                            'Hydraulic'
                          )
                        "
                        placeholder="Numeric value for outlet"
                        ngDefaultControl
                        formControlName="outputNoHydraulicCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasError('outputNoHydraulicCtr', 'required')
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasError('outputNoHydraulicCtr', 'min') ||
                          isFieldHasError('outputNoHydraulicCtr', 'max')
                        "
                      >
                        Number of Output Sensing Point is greater than 0 and
                        less than or equal to 10.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Has Energy Meter?</mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <section class="example-section">
                      <input
                        ngDefaultControl
                        [ngModelOptions]="{ standalone: true }"
                        type="radio"
                        [(ngModel)]="load.hasEnergyMeter"
                        name="HydraulicCheckBox"
                        value="YES"
                        (ngModelChange)="onHasEnergyMeterChange('hydraulicCtr')"
                      />
                      <mat-label class="example-margin"> &nbsp; Yes</mat-label>
                      &nbsp;
                      <input
                        ngDefaultControl
                        [ngModelOptions]="{ standalone: true }"
                        type="radio"
                        [(ngModel)]="load.hasEnergyMeter"
                        name="HydraulicCheckBox"
                        value="NO"
                        (ngModelChange)="onHasEnergyMeterChange('hydraulicCtr')"
                      />
                      <mat-label class="example-margin"> &nbsp; No</mat-label>
                    </section>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="load.hasEnergyMeter === 'NO'">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Machine ID:
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        [(ngModel)]="load.machineID"
                        matInput
                        type="number"
                        placeholder="Enter Unique ID for Load"
                        ngDefaultControl
                        formControlName="machineIDHydraulicCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasError('machineIDHydraulicCtr', 'required')
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <mat-label class="label-input"
                  >Input Sensing Point Details</mat-label
                >
              </div>
              <hr />
              <div class="row">
                <div
                  formArrayName="inletHydraulicItems"
                  class="col-md-3"
                  *ngFor="let flowChannel of load.inlets; let $index = index"
                >
                  <div [formGroupName]="$index">
                    <mat-label class="label-input" style="font-weight: bold"
                      >Enter InputSensingPoint
                      {{ $index + 1 }} Details:</mat-label
                    ><br />
                    <mat-form-field>
                      <input
                        [(ngModel)]="flowChannel.name"
                        matInput
                        placeholder="Enter Sensed Parameter Name"
                        (change)="onInputNameHydraulicChange($index, 'inlet')"
                        ngDefaultControl
                        formControlName="inputNameCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'minlength',
                            'inlet'
                          ) ||
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'maxlength',
                            'inlet'
                          )
                        "
                      >
                        Please legthen this text to 3 characters and less than
                        30 characters.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'inputInletNameUniqueValidator',
                            'inlet'
                          )
                        "
                      >
                        Name cannot be repeated.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.flowChannelID"
                        placeholder="Enter Flow Channel ID"
                        (change)="
                          onFlowChannelIDHydraulicChange($index, 'inlet')
                        "
                        ngDefaultControl
                        formControlName="inputIDCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'minlength',
                            'inlet'
                          ) ||
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'maxlength',
                            'inlet'
                          )
                        "
                      >
                        Please legthen this text to 1 characters and less than
                        60 characters.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'inputInletIDUniqueValidator',
                            'inlet'
                          )
                        "
                      >
                        FlowChannelID cannot be repeated.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.ioChannnelSerialNumber"
                        placeholder="Enter IO Serial Number"
                        ngDefaultControl
                        formControlName="ioChannnelSerialNumberCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'ioChannnelSerialNumberCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>-- Select Parameter Type --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.parameterType"
                        ngDefaultControl
                        formControlName="parameterTypeCtr"
                      >
                        <mat-option
                          *ngFor="let item of hydraulicParameterType"
                          [value]="item"
                          >{{ item }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'parameterTypeCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                        >Please Select Parameter Type</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="
                          flowChannel.sensor.parameterTypeDisplayValue
                        "
                        placeholder="Enter ParameterType DisplayName"
                        ngDefaultControl
                        formControlName="parameterTypeDisplayValueCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'minlength',
                            'inlet'
                          ) ||
                          isFieldHasErrorinHydraulic(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'maxlength',
                            'inlet'
                          )
                        "
                      >
                        Please legthen this text to 2 characters and less than
                        30 characters.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>-- Select Sensor Output Type --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.outputType"
                        ngDefaultControl
                        (ngModelChange)="
                          onOutTypeChange('HydraulicInlet', $index)
                        "
                        formControlName="outputTypeCtr"
                        required
                      >
                        <mat-option>-- Select Sensor Output Type --</mat-option>
                        <mat-option
                          *ngFor="let item of hydraulicOutputType"
                          [value]="item.value"
                          >{{ item.text }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'outputTypeCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                        >Select Sensor Output Type</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field
                      *ngIf="flowChannel.sensor.outputType === 'Switch'"
                    >
                      <mat-label>-- Select DI0 / DI1 --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.digitalOutputMapping"
                        ngDefaultControl
                        formControlName="digitalOutputMappingCtr"
                        required
                      >
                        <mat-option>-- Select DI0 / DI1 --</mat-option>
                        <mat-option
                          *ngFor="let item of digitalOutputMapping"
                          [value]="item"
                          >{{ item.di_0 }} / {{ item.di_1 }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'digitalOutputMappingCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                        >Select DI0 / DI1</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.sensor.sensorPartNumber"
                        placeholder="Enter Sensor Part Number"
                        ngDefaultControl
                        formControlName="sensorPartNumberCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'sensorPartNumberCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.lowerThresholdTempertaure"
                        placeholder="Enter Lower Threshold Temperature"
                        (change)="
                          onLowerThresholdHydraulicChange($index, 'inlet')
                        "
                        ngDefaultControl
                        formControlName="inletThresholdTempCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletThresholdTempCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletThresholdTempCtr',
                            $index,
                            'isInletLowerThresholdValid'
                          )
                        "
                      >
                        Inlet Lower Threshold cannot be Equal / Greater than
                        Upper Threshold Value
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.upperThresholdTemperature"
                        placeholder="Enter Upper Threshold Temperature"
                        (change)="
                          onUpperThresholdHydraulicChange($index, 'inlet')
                        "
                        ngDefaultControl
                        formControlName="inletUpperThresholdTempCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'required',
                            'inlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'isInletUpperThresholdValid'
                          )
                        "
                      >
                        Inlet Upper Threshold cannot be less than Equal / Lower
                        than Lower Threshold Value
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <mat-label class="label-input"
                  >Output Sensing Point Details</mat-label
                ><br />
              </div>
              <hr />
              <div class="row">
                <div
                  formArrayName="outletHydraulicItems"
                  class="col-md-3"
                  *ngFor="let flowChannel of load.outlets; let $index = index"
                >
                  <div [formGroupName]="$index">
                    <mat-label class="label-input" style="font-weight: bold"
                      >Enter OutputSensingPoint
                      {{ $index + 1 }} Details:</mat-label
                    ><br />
                    <mat-form-field>
                      <input
                        [(ngModel)]="flowChannel.name"
                        matInput
                        placeholder="Enter Sensed Parameter Name"
                        (change)="onInputNameHydraulicChange($index, 'outlet')"
                        ngDefaultControl
                        formControlName="inputNameCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'minlength',
                            'outlet'
                          ) ||
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'maxlength',
                            'outlet'
                          )
                        "
                      >
                        Please legthen this text to 3 characters and less than
                        30 characters.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputNameCtr',
                            $index,
                            'inputOutletNameUniqueValidator',
                            'outlet'
                          )
                        "
                      >
                        Name cannot be repeated.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.flowChannelID"
                        placeholder="Enter Flow Channel ID"
                        (change)="
                          onFlowChannelIDHydraulicChange($index, 'outlet')
                        "
                        ngDefaultControl
                        formControlName="inputIDCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'minlength',
                            'outlet'
                          ) ||
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'maxlength',
                            'outlet'
                          )
                        "
                      >
                        Please legthen this text to 1 characters and less than
                        60 characters.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inputIDCtr',
                            $index,
                            'inputOutletIDUniqueValidator',
                            'outlet'
                          )
                        "
                      >
                        FlowChannelID cannot be repeated.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.ioChannnelSerialNumber"
                        placeholder="Enter IO Serial Number"
                        ngDefaultControl
                        formControlName="ioChannnelSerialNumberCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'ioChannnelSerialNumberCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>-- Select Parameter Type --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.parameterType"
                        ngDefaultControl
                        formControlName="parameterTypeCtr"
                      >
                        <mat-option
                          *ngFor="let item of hydraulicParameterType"
                          [value]="item"
                          >{{ item }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'parameterTypeCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                        >Please Select Parameter Type</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="
                          flowChannel.sensor.parameterTypeDisplayValue
                        "
                        placeholder="Enter ParameterType DisplayName"
                        ngDefaultControl
                        formControlName="parameterTypeDisplayValueCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'minlength',
                            'outlet'
                          ) ||
                          isFieldHasErrorinHydraulic(
                            'parameterTypeDisplayValueCtr',
                            $index,
                            'maxlength',
                            'outlet'
                          )
                        "
                      >
                        Please legthen this text to 2 characters and less than
                        30 characters.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>-- Select Sensor Output Type --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.outputType"
                        ngDefaultControl
                        (ngModelChange)="
                          onOutTypeChange('HydraulicOutlet', $index)
                        "
                        formControlName="outputTypeCtr"
                        required
                      >
                        <mat-option>-- Select Sensor Output Type --</mat-option>
                        <mat-option
                          *ngFor="let item of hydraulicOutputType"
                          [value]="item.value"
                          >{{ item.text }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'outputTypeCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                        >Select Sensor Output Type</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field
                      *ngIf="flowChannel.sensor.outputType === 'Switch'"
                    >
                      <mat-label>-- Select DI0 / DI1 --</mat-label>
                      <mat-select
                        [(ngModel)]="flowChannel.sensor.digitalOutputMapping"
                        ngDefaultControl
                        formControlName="digitalOutputMappingCtr"
                        required
                      >
                        <mat-option>-- Select DI0 / DI1 --</mat-option>
                        <mat-option
                          *ngFor="let item of digitalOutputMapping"
                          [value]="item"
                          >{{ item.di_0 }} / {{ item.di_1 }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'digitalOutputMappingCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                        >Select DI0 / DI1</mat-error
                      >
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        [(ngModel)]="flowChannel.sensor.sensorPartNumber"
                        placeholder="Enter Sensor Part Number"
                        ngDefaultControl
                        formControlName="sensorPartNumberCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'sensorPartNumberCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.lowerThresholdTempertaure"
                        placeholder="Enter Lower Threshold Temperature"
                        (change)="
                          onLowerThresholdHydraulicChange($index, 'outlet')
                        "
                        ngDefaultControl
                        formControlName="inletThresholdTempCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletThresholdTempCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletThresholdTempCtr',
                            $index,
                            'isOutletLowerThresholdValid',
                            'outlet'
                          )
                        "
                      >
                        Outlet Lower Threshold cannot be Equal / Greater than
                        Upper Threshold Value
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="flowChannel.upperThresholdTemperature"
                        placeholder="Enter Upper Threshold Temperature"
                        (change)="
                          onUpperThresholdHydraulicChange($index, 'outlet')
                        "
                        ngDefaultControl
                        formControlName="inletUpperThresholdTempCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'required',
                            'outlet'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                      <mat-error
                        *ngIf="
                          isFieldHasErrorinHydraulic(
                            'inletUpperThresholdTempCtr',
                            $index,
                            'isOutLetUpperThresholdValid',
                            'outlet'
                          )
                        "
                      >
                        Outlet Upper Threshold cannot be Equal / Greater than
                        Lower Threshold Value
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <!-- Operation Details -->
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>Operation Details</h6>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Input Constraints:</mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        matInput
                        placeholder="Input Constraints"
                        ngDefaultControl
                        formControlName="inputConstraintCtr"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Output Constraints:</mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        matInput
                        placeholder="Output Constraints"
                        ngDefaultControl
                        formControlName="outputConstraintCtr"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Ideal Power consumption:
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="load.idealPowerConsumption"
                        placeholder="Power consumption"
                        ngDefaultControl
                        formControlName="idealPowerConsumptionCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasError(
                            'idealPowerConsumptionCtr',
                            'required'
                          )
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >Maintenance Window(Hours):
                      <span class="iep-required">*</span></mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <mat-form-field>
                      <input
                        type="number"
                        matInput
                        [(ngModel)]="load.maintenancewindow"
                        placeholder="Maintenance Window in Hours"
                        ngDefaultControl
                        formControlName="maintenancewindowCtr"
                        required
                      />
                      <mat-error
                        *ngIf="
                          isFieldHasError('maintenancewindowCtr', 'required')
                        "
                      >
                        This field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-4">
                    <mat-label class="label-input pull-right"
                      >DR Flexibility 0-100%</mat-label
                    >
                  </div>
                  <div class="col-md-8">
                    <section class="example-section">
                      <mat-label class="example-margin">Yes</mat-label> &nbsp;
                      <input
                        [ngModelOptions]="{ standalone: true }"
                        ngDefaultControl
                        type="radio"
                        [(ngModel)]="tempModel.drflexibility"
                        name="drflexibility"
                        value="Yes"
                        (ngModelChange)="onDrflexibilityChange()"
                      />

                      &nbsp;
                      <mat-label class="example-margin">
                        &nbsp; Not Known</mat-label
                      >&nbsp;
                      <input
                        [ngModelOptions]="{ standalone: true }"
                        ngDefaultControl
                        type="radio"
                        [(ngModel)]="tempModel.drflexibility"
                        name="drflexibility"
                        value="No"
                        (ngModelChange)="onDrflexibilityChange()"
                      />
                    </section>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="tempModel.drflexibility === 'Yes'">
                  <mat-form-field>
                    <input
                      matInput
                      [(ngModel)]="load.drflexibility"
                      placeholder="DR Flexibility in %"
                      ngDefaultControl
                      formControlName="drflexibilityCtr"
                    />
                    <mat-error
                      *ngIf="
                        isFieldHasError('drflexibilityCtr', 'minlength') ||
                        isFieldHasError('drflexibilityCtr', 'maxlength')
                      "
                    >
                      Please legthen this text to 1 characters and less than 3
                      characters.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                class="row"
                *ngIf="tempModel.drflexibility === 'Yes'"
                style="display: flex; align-items: center"
              >
                <div class="col-md-2">
                  <mat-label class="label-input pull-right"
                    >Time Slot Number:</mat-label
                  >
                </div>
                <div class="col-md-10">
                  <mat-label
                    >Value 1: {{ items[1].value }} / Value 2:
                    {{ items[2].value }}</mat-label
                  >
                </div>
              </div>
            </mat-expansion-panel>
            <!-- Other Details -->
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h6>Other Details</h6>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field>
                    <textarea
                      [(ngModel)]="load.comment"
                      ngDefaultControl
                      matInput
                      placeholder="- Please enter any other additional details about the load to describe its working, number of times the load broke down in last 2 years, MTBF, MTTR etc.
                              - Maximum 200 words text."
                      formControlName="commentCtr"
                    ></textarea>
                    <mat-error
                      *ngIf="isFieldHasError('commentCtr', 'maxlength')"
                    >
                      Please input maximum 200 Characters.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-expansion-panel>
            <br />
            <!-- Button -->
            <div class="col-md-12" style="text-align: center">
              <button
                bciprimarybutton
                class="button-primary"
                type="submit"
                [disabled]="!formMasterGroup.valid"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="weather icon"
                    class="bosch-ic-checkmark-frame"
                    style="width: max-content"
                  ></mat-icon>
                </span>
                Submit
              </button>
              &nbsp;
              <button
                bciprimarybutton
                class="button-primary"
                (click)="reset($event)"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="weather icon"
                    class="bosch-ic-reset"
                    style="width: max-content"
                  ></mat-icon>
                </span>
                Reset
              </button>
              &nbsp;
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
